import {
    Box,
    Typography,
    useTheme,
    Stack
} from "@mui/material";
import { tokens } from "../../theme";
import useResponsive from "../../hooks/useResponsive";
import {Link} from 'react-router-dom';
import ChatComponent from "./Chat";
import NoChat from "./NoAppeal";



const Appeal = ({ handleOpenSearch=null }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const isDesktop = useResponsive("up", "md");

    return (
        <Box
            sx={{
                position: "relative",
                // height: "100%",
                minWidth: "320px",
                width: "100%"
                // width: isDesktop ? 320 : "100%",
            }}
            backgroundColor={colors.primary[400]}
        >
            <ChatComponent handleOpenSearch={handleOpenSearch}/>
            
        </Box>
    )
};

export default Appeal;